import Service from './service'
export var ApiAudioMessageType;
(function (ApiAudioMessageType) {
  ApiAudioMessageType["RECORD_AUDIO_REQUEST"] = "record.audio.request"
  ApiAudioMessageType["RECORD_AUDIO_RESPONSE"] = "record.audio.response"
})(ApiAudioMessageType || (ApiAudioMessageType = {}))
export var AudioMessageType;
(function (AudioMessageType) {
  AudioMessageType["AUDIO_RESPONSE"] = "AUDIO_RESPONSE"
  AudioMessageType["AUDIO_RECORD_START"] = "AUDIO_RECORD_START"
})(AudioMessageType || (AudioMessageType = {}))
/**
 * Сервис для работы с аудио
 * @version 0.0.1
 * @since 1.9.0
 */
export default class AudioService extends Service {
  /**
     * @ignore
     */
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiAudioMessageType.RECORD_AUDIO_RESPONSE:
          if (typeof message.file !== 'undefined') {
            this.broadcast(AudioMessageType.AUDIO_RESPONSE, message.file)
          }
          break
      }
    }
    this.messageChannel.subscribe(ApiAudioMessageType.RECORD_AUDIO_RESPONSE, messageHandler)
  }
  /**
     * Сервис записи аудио ответил
     * @since 1.9.0
     *
     * @param {(filename: string) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof AudioService
     *
     * @example <caption>cервис записи аудио ответил</caption>
     * robot.audioService.onAudioResponse((filename) => {
     *   ...
     * })
     */
  onAudioResponse(callback) {
    return this.subscribe(AudioMessageType.AUDIO_RESPONSE, callback)
  }
  /**
     * Сервис записи аудио начал записывать
     * @since 1.9.0
     *
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof AudioService
     *
     * @example <caption>cервис записи начал записывать</caption>
     * robot.audioService.onRecordStart(() => {
     *   ...
     * })
     */
  onRecordStart(callback) {
    return this.subscribe(AudioMessageType.AUDIO_RECORD_START, callback)
  }
  /**
     * Начать запись аудио
     * @since 1.9.0
     *
     * @param {number} [timeout=20] - длительность записи
     * @memberof AudioService
     *
     * @example <caption>начать запись аудио</caption>
     * robot.audioService.start()
     */
  start(timeout = 20) {
    this.broadcast(AudioMessageType.AUDIO_RECORD_START)
    this.messageChannel.send({
      type: ApiAudioMessageType.RECORD_AUDIO_REQUEST,
      start: '',
      timeout,
    })
  }
  /**
     * Остановить запись аудио
     * @since 1.9.0
     *
     * @memberof AudioService
     *
     * @example <caption>остановить запись аудио</caption>
     * robot.audioService.stop()
     */
  stop() {
    this.messageChannel.send({
      type: ApiAudioMessageType.RECORD_AUDIO_REQUEST,
      stop: '',
    })
  }
}
